import { useCallback, useEffect, useState } from "react"

type MonetagShowFn = (v: MonetagCallbackType) => Promise<void>

declare global {
  interface Window {
    [key: `show_${number}`]: MonetagShowFn
  }
}

type MonetagCallbackType = {
  type?: 'end' | 'start' | 'preload' | 'pop' | 'inApp',
  ymid?: string,
  requestVar?: string,
  timeout?: number,
  catchIfNoFeed?: boolean,
  inAppSettings?: {
    frequency: number,
    capping: number,
    interval: number,
    timeout: number,
    everyPage?: boolean
  }
}
export const useMonetag = (zoneId: number) => {
  useEffect(() => {
    const selector = `script[data-zone='${zoneId}']`
    if (document.querySelector(selector)) {
      return
    }

    const script = document.createElement('script')
    script.src = '/ads/sdk.js'
    script.async = true
    script.dataset.zone = String(zoneId)
    script.dataset.sdk = `show_${zoneId}`
    
    document.head.appendChild(script)
  }, [zoneId])

  const show = useCallback(() => {
    // TODO: можно выкинуть что-то в духе wait a few seconds или шо то такое
    if (!window[`show_${zoneId}`]) return Promise.resolve()
    return window[`show_${zoneId}`]({ type: 'end' })
  }, [])

  return { show }
}